module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    class: _vm.$style.root
  }, [_c('progress-bar'), (_vm.navOpen) ? _c('div', {
    staticClass: "modal-backdrop navigation-backdrop show",
    on: {
      "click": _vm.closeNavigation
    }
  }) : _vm._e(), _c('b-navbar', {
    attrs: {
      "toggleable": "toggleable",
      "type": "inverse",
      "variant": "",
      "toggle-breakpoint": "md"
    }
  }, [_c('b-nav-toggle', {
    attrs: {
      "target": "navCollapse"
    }
  }), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/",
      "name": "link_header_logo_to_home"
    }
  }, [_c('div', {
    staticClass: "header-logo"
  })]), _c('b-collapse', {
    ref: "headerNav",
    staticClass: "top-navigation",
    attrs: {
      "id": "navCollapse",
      "is-nav": "is-nav"
    }
  }, [(_vm.userFullName) ? _c('div', {
    staticClass: "welcome menu-box hidden-lg-up"
  }, [_vm._v(_vm._s(_vm.$t('pos.header.user', {
    name: _vm.userFullName
  })))]) : _vm._e(), _c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": "is-nav-bar"
    }
  }, [(_vm.userFullName) ? [_c('b-nav-item', {
    attrs: {
      "to": "/campaign/new"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.create')))]), _c('b-nav-item', {
    attrs: {
      "to": "/proposals"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.saved')))]), _c('b-nav-item', {
    attrs: {
      "to": "/examples"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.examples')))])] : _vm._e(), (_vm.showLanguageSelector) ? [_c('b-dropdown-divider'), _c('div', {
    class: {
      mobile: _vm.notLoggedIn
    }
  }, _vm._l((_vm.availableLanguages), function(code) {
    return _c('b-dropdown-item', {
      key: code,
      staticClass: "hidden-lg-up",
      class: {
        selected: _vm.language === code
      },
      attrs: {
        "name": _vm.getLanuageLink(code)
      },
      on: {
        "click": function($event) {
          _vm.localeSelect(code)
        }
      }
    }, [_vm._v(_vm._s(_vm.localeService.translateInLocale(code, 'locale_native_name'))), _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }))] : _vm._e()], 2), _c('div', {
    staticClass: "additional menu-box hidden-lg-up"
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": _vm.famUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.go-to-fam')))]), (_vm.offlineModeEnabled) ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.$refs.offlineMode.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.setup-offline-mode')))]) : _vm._e(), (_vm.userFullName) ? _c('b-button', {
    staticClass: "btn-block btn-logout mt-3",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.signout')))]) : _vm._e()], 1), _c('b-nav', {
    staticClass: "hidden-md-down",
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.userFullName || !_vm.showLanguageSelector) ? _c('b-nav-item-dropdown', {
    staticClass: "desktop-dropdown",
    attrs: {
      "right-alignment": "right-alignment"
    }
  }, [_c('template', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [(_vm.userFullName) ? [_c('offline-button'), _c('div', {
    staticClass: "username username-header",
    class: {
      online: _vm.isOnline, offline: !_vm.isOnline
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.user', {
    name: _vm.userFullName
  }))), _c('icon', {
    staticClass: "menu-chevron",
    attrs: {
      "name": "chevron-down"
    }
  })], 1)] : _c('div', {
    staticClass: "text-right"
  }, [_c('icon', {
    staticClass: "menu-chevron",
    attrs: {
      "name": "chevron-down"
    }
  })], 1)], 2), _c('b-dropdown-divider'), (_vm.offlineModeEnabled) ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.$refs.offlineMode.showModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.setup-offline-mode')))]) : _vm._e(), _c('b-dropdown-item', {
    attrs: {
      "href": _vm.famUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.go-to-fam')))]), (_vm.userFullName) ? _c('b-dropdown-item', [_c('b-button', {
    staticClass: "btn-block btn-logout",
    attrs: {
      "variant": "success",
      "name": "link_header_to_singout"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.header.signout')))])], 1) : _vm._e()], 2) : _vm._e(), (_vm.showLanguageSelector) ? _c('b-nav-item-dropdown', {
    staticClass: "desktop-dropdown language-selector",
    attrs: {
      "right-alignment": "right-alignment"
    }
  }, _vm._l((_vm.availableLanguages), function(code) {
    return _c('b-dropdown-item', {
      key: code,
      class: {
        selected: _vm.language === code
      },
      attrs: {
        "name": _vm.getLanuageLink(code)
      },
      on: {
        "click": function($event) {
          _vm.localeSelect(code)
        }
      }
    }, [_vm._v(_vm._s(_vm.localeService.translateInLocale(code, 'locale_native_name'))), _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  })) : _vm._e()], 1)], 1)], 1), (_vm.offlineModeEnabled) ? _c('offline-mode', {
    ref: "offlineMode"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed4f211"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Header.vue
// module id = 921
// module chunks = 1